export const calculateInterval = (from: number, to: number, duration: number): number => {
  const timePerNumber = Math.max(10, duration / (Math.abs(from - to) + 1));
  const interval = duration / timePerNumber;
  return interval;
};

export const generateNumberSlideKeyframes = (len: number, reverse?: boolean): Keyframe[] => {
  const from = { transform: `translateY(0%)` };
  const to = { transform: `translateY(${100 / len - 100}%)` };
  return reverse ? [to, from] : [from, to];
};

export const generateSequence = (start: number, end: number, duration: number): number[] => {
  const interval = calculateInterval(start, end, duration);
  const step = (end - start) / interval;
  const values = [];

  let previousValue: number | null = null;
  for (let i = 0; i <= interval; i++) {
    const value = Math.ceil(start + step * i);
    if (value !== previousValue) {
      values.push(value);
      previousValue = value;
    }
  }

  if (values[values.length - 1] !== end) values.push(end);

  if (start > end) values.reverse();

  return values;
};
